import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setExceptionHandler } from '@app/store/actions';
import { accountService, basicService } from '@app/services';
import { ResetPasswordChooseComponent } from './components';
import { onSubmitUserCheck } from './helpers';
import { DataForPswResetSmsResponse, ResetPasswordErrorType } from '@app/models';
import { RESET_OPTION_EMAIL_NONE } from '@app/helpers';

const ResetPasswordPage = () => {
    const dispatch = useDispatch();
    const usernameQueryString = basicService.getQueryVariable('user');
    const resetTokenQueryString = basicService.getQueryVariable('resetToken');

    const [username, setUsername] = useState<string>(usernameQueryString);
    const [isErrorValidateUsername, setIsErrorValidateUsername] = useState<ResetPasswordErrorType>({
        isUsernameInvalid: false,
        isEmptyUsername: false
    });
    const [resetTokenObject, setResetTokenObject] = useState<DataForPswResetSmsResponse | undefined>(undefined);
    // API response contains which reset methods are available here
    // 4 = email and sms
    // 3 = email
    // 1 = sms
    // 400 = none
    const [availableResetOptions, setAvailableResetOptions] = useState<string>('0');

    useEffect(() => {
        dispatch(setExceptionHandler(true));
        if (username) {
            accountService.validateUsername(
                username,
                () => {
                    setIsErrorValidateUsername({ isUsernameInvalid: true, isEmptyUsername: false });
                },
                (res: Record<string, any>) => {
                    setAvailableResetOptions(res.data?.state ?? RESET_OPTION_EMAIL_NONE);

                    if (resetTokenQueryString) {
                        let rto: DataForPswResetSmsResponse = {
                            username: username,
                            resetToken: resetTokenQueryString,
                            canChangePassword: res.data?.canChangePassword,
                            resetRequiresVerification: res.data?.resetRequiresVerification
                        };

                        setResetTokenObject(rto);
                    }
                }
            );
        }
    }, []);

    const handleSubmit = () =>
        onSubmitUserCheck(username, setIsErrorValidateUsername, (res: Record<string, any>) => {
            setAvailableResetOptions(res.data?.state ?? RESET_OPTION_EMAIL_NONE);
        });

    return (
        <div className='forgot-password'>
            <div className='forgot-password__wrapper'>
                <div className='forgot-password__container'>
                    <div className='forgot-password__form'>
                        <ResetPasswordChooseComponent
                            onSubmitUserCheck={handleSubmit}
                            setUsername={setUsername}
                            availableResetOptions={availableResetOptions}
                            isErrorValidateUsername={isErrorValidateUsername}
                            resetTokenObject={resetTokenObject}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
